import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';

export default class OverviewLink extends Component {
  static propTypes = {
    onClickHandler: PropTypes.func,
    theme: PropTypes.string,
    children: PropTypes.string,
    href: PropTypes.string,
    hrefExternal: PropTypes.string,
    hrefExternalTarget: PropTypes.string
  };

  constructor(props) {
    super(props);
  }

  render() {
    let linkTag;
    const {
      onClickHandler,
      children,
      theme,
      href,
      hrefExternal,
      hrefExternalTarget
    } = this.props;
    const classname = `overviewLink__button${theme ? '--' + theme : ''}`;
    if (hrefExternal) {
      linkTag = <a onClick={onClickHandler} className={classname} href={hrefExternal}>{children}</a>;
    } else if (hrefExternalTarget) {
      linkTag = <a onClick={onClickHandler} target="_blank" className={classname} href={hrefExternalTarget}>{children}</a>;
    } else if (href) {
      linkTag = <Link onClick={onClickHandler} className={classname} to={href}>{children}</Link>;
    } else {
      linkTag = <a className={classname}>{children}</a>;
    }

    return (
      <div>
        {linkTag}
      </div>
    );
  }
}
